import React from 'react';
import { Button, Table } from 'flowbite-react';
import { MdAdd } from 'react-icons/md';

type Props = {
	availableDurations: number[];
	onAddDurationTab: (duration: number) => void;
};

const AddDurations = ({ availableDurations, onAddDurationTab }: Props) => {
	if (availableDurations.length === 0) {
		return (
			<div className="mt-10 h-full flex justify-center items-center">
				<div>No More Available Durations</div>
			</div>
		);
	}
	return (
		<Table>
			<Table.Head>
				<Table.HeadCell>Slot Duration (min)</Table.HeadCell>
				<Table.HeadCell>Action</Table.HeadCell>
			</Table.Head>
			<Table.Body>
				{availableDurations.map((duration: number) => (
					<Table.Row key={duration}>
						<Table.Cell>{duration} min</Table.Cell>
						<Table.Cell>
							<Button color="purplePlaced" onClick={() => onAddDurationTab(duration)} size={'sm'}>
								<MdAdd /> Add
							</Button>
						</Table.Cell>
					</Table.Row>
				))}
			</Table.Body>
		</Table>
	);
};

export default AddDurations;
